<template>
  <div
    v-if="modalIsOpened"
    class="fixed inset-0 w-full bg-black/30"
    @click.self="closeModal"
  >
    <div
      class="fixed inset-0 overflow-y-auto flex items-start justify-center py-8"
    >
      <div class="w-[100vw] max-w-[350px] px-[20px] overflow-hidden m-auto">
        <!-- actual modal -->
        <div class="mx-auto box-effect rounded-[10px] bg-white overflow-hidden">
          <div
            id="title"
            class="flex items-center justify-between py-[12px] pl-[20px] pr-[10px] bg-[#9B237B]"
          >
            <span class="PC_Body2-R text-[#FCFCFC]">
              {{ checkEdit ? "แก้ไขตำแหน่งงาน" : "เพิ่มตำแหน่งงาน" }}
            </span>
            <CloseIcon
              @click="closeModal"
              class="w-[24px] h-[24px] bg-white text-[#9B237B] rounded-full cursor-pointer"
            />
          </div>

          <div class="flex flex-col p-[20px] pt-[12px] gap-[16px] bg-[#FCFCFC]">
            <Input
              label="ชื่อตำแหน่งงาน"
              placeholder="ชื่อตำแหน่งงาน"
              v-model="form.name"
              :warningMessage="errors.name"
            />
            <div class="w-full flex justify-center items-center gap-[10px]">
              <ButtonComponent
                :label="'บันทึก'"
                :bClass="'btn_shadow--onlySave'"
                :disabled="form.name == ''"
                @clicked="save"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { useGlobals } from "@/components/Utilities/javascripts/useGlobals";
import { usePositionStore } from "@/pinia/position";

const { $validateMsg } = useGlobals();
const positionStore = usePositionStore();

const input = {
  id: "",
  name: "",
};
const form = ref({ ...input });
const errors = ref({ ...input });
const checkEdit = ref(false);
const modalIsOpened = ref(false);

const emit = defineEmits(["success"]);

const openModal = (item) => {
  modalIsOpened.value = true;
  document.body.style.overflow = "hidden";
  checkEdit.value = !!item;
  if (item) {
    form.value.id = item.id;
    form.value.name = item.name;
  } else {
    form.value = {
      ...input,
    };
    errors.value = {
      ...input,
    };
  }
};

const closeModal = () => {
  modalIsOpened.value = false;
  document.body.style.overflow = "auto";
};

const save = () => {
  if (checkEdit.value) {
    update();
  } else {
    add();
  }
};

const update = async () => {
  await positionStore
    .updatePosition(form.value)
    .then((response) => {
      if (response.status === 200) {
        emit("success", response.data.message);
        closeModal();
      }
    })
    .catch((error) => {
      if (error) {
        $validateMsg(error.response.data.errors, errors.value);
      }
    });
};

const add = async () => {
  await positionStore
    .createPosition(form.value)
    .then((response) => {
      if (response.status === 201) {
        emit("success", response.data.message);
        closeModal();
      }
    })
    .catch((error) => {
      if (error) {
        $validateMsg(error.response.data.errors, errors.value);
      }
    });
};

defineExpose({ openModal });
</script>
    
<style scoped>
</style>